export default __webpack_public_path__ + "static/media/TZ.ee86ef07.svg";